type CamelToSnake<S extends string> = S extends `${infer First}${infer Rest}`
  ? First extends Lowercase<First>
    ? `${First}${CamelToSnake<Rest>}`
    : `_${Lowercase<First>}${CamelToSnake<Rest>}`
  : S;

export function camelToSnake<T extends string>(value: T): CamelToSnake<T> {
  return value.replace(/[A-Z]/g, letter => `_${letter.toLowerCase()}`) as CamelToSnake<T>;
}

export const kebabCaseToCamelCase = (string: string): string => string.replace(/-./g, x => (x[1] ?? "").toUpperCase());

export const upperCaseToKebabCase = (string: string): string =>
  string.replace(
    /([A-Z])([A-Z]*)_?/g,
    (match, p1, p2) => p1.toLowerCase() + p2.toLowerCase() + (match.endsWith("_") ? "-" : ""),
  );

export const upperCaseToCamelCase = (string: string): string =>
  string.toLowerCase().replace(/_([a-z])/g, (_, p1) => p1.toUpperCase());
